import { Link } from 'react-router-dom';
import styles from './AuthSwitchLink.module.css';

/**
 * Bottom "switch account" affordance — a plain text link (design pattern), e.g.
 * "Already have account? Sign in" / "Don't have an account? Sign up". Not a button.
 */
export function AuthSwitchLink({
  prompt,
  action,
  to,
  state,
}: {
  prompt: string;
  action: string;
  to: string;
  state?: unknown;
}) {
  return (
    <p className={styles.line}>
      {prompt}{' '}
      <Link to={to} state={state} className={styles.link}>
        {action}
      </Link>
    </p>
  );
}

export default AuthSwitchLink;
